const url = window.location.origin;

export const SET_USER = url + '/wp-json/wp/v2/amsive-comments/user';
export const GET_COMMENT = url + '/wp-json/wp/v2/amsive-comments/get';
export const ADD_COMMENT = url + '/wp-json/wp/v2/comments';